import { useHeightAvailable } from "@repoflow/components/content-resize";
import { useEffect, useRef } from "react";
import React, { useContext } from "react";

const Context = React.createContext(null);

export const useContentAvailableContext = () => {
  return useContext(Context);
};

const $ = window.$;

export const Content = ({
  children,
  onScroll,
  className,
  height: heightIn,
}) => {
  const { refContent: content, width, height, top } = useHeightAvailable();



  return (
    <div
      className={className + " overflow-auto"}
      ref={content}
      style={{ height: heightIn ? heightIn : "calc(100vh - " + top + "px)" }}
    >
      <Context.Provider value={{ width, height }}>{children}</Context.Provider>
    </div>
  );
};
